import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class RoadmapTableInitiativePlanningWorkstreamsController extends Controller {
  @service store;
  @service('current-user') currentUser;
  @service('beta-toggle') betaService;
  @service initiativeSlideover;
  @service router;

  @tracked workstreams = [];

  @tracked workstream_form = null;
  @tracked showCreateModal = false;

  visibleBadges = ['teams', 'weeks', 'delay'];
  catchAllBadges = ['teams', 'weeks', 'delay', 'workstreams'];

  get catchAllItems() {
    return this.store.peekAll('tfo').filter((item) => {
      const workstream = item.get('workstream');
      const initiative = item?.initiative.get('id');
      if (
        !workstream.isTruthy &&
        initiative === this.model.id &&
        !item.archived
      )
        return true;
      else return false;
    });
  }

  @action
  async addWorkstream(changeset) {
    if (changeset.title && changeset?.title?.trim()?.length <= 0) return;
    if (
      this.workstreams
        .slice()
        .map((item) => item.title)
        .includes(changeset.title)
    )
      return;
    try {
      this.workstream_form.title = changeset.title.trim();
      this.workstream_form.position = 1;
      this.workstream_form.initiative = this.model;
      this.workstream_form.author = await this.currentUser.getActiveUser();
      this.workstream_form.save().then(() => {
        this.toggleModal(false);
        changeset.rollback();
      });
    } catch (err) {
      console.log(err);
    }
  }

  @action
  toggleModal(val = false) {
    this.showCreateModal = val;
    if (val === false) {
      this.workstream_form = null;
    } else {
      this.workstream_form = this.store.createRecord('workstream');
      document.querySelector('#title')?.focus();
    }
  }

  @action
  onSubmit(e) {
    e.preventDefault();
    document.querySelector('#save-workstream').click();
  }

  @action
  handleWorkstreamEdit(workstream) {
    this.workstream_form = workstream;
    this.showCreateModal = true;
    document.querySelector('#title')?.focus();
  }

  get isEditingWorkstream() {
    return !this.workstream_form?.id;
  }

  @action
  handleSettingsSlideoverOpen() {
    this.initiativeSlideover.open(this.model.id);
  }

  @action
  archiveAllCheckedItems() {
    const tfos = this.store
      .peekAll('tfo')
      .slice()
      .filter(
        (item) =>
          item.initiative.get('id') === this.model.id &&
          item.completed === true,
      );
    tfos.forEach((item) => {
      item.archived = true;
      item.save();
    });
    this.hideTippy();
  }

  @action
  goToWorkstreamArchives(id) {
    const workstream = this.store.peekRecord('workstream', id);
    this.router.transitionTo(
      'backlog.initiatives.initiative.planning.workstreams.workstream.archive',
      this.model.id,
      workstream.id,
    );
    this.hideTippy();
  }

  @action
  onArchiveTippyCreate(instance) {
    this.archiveTippyInstance = instance;
  }

  @action
  hideTippy() {
    this.archiveTippyInstance?.hide();
  }
}
